import { BoxLeadFormLayout } from "@modules/boxLead/components/boxLeadForm/boxLeadFormLayout"
import { BoxLeadEntity } from "@modules/boxLead/entities/boxLeadEntity"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { HUText } from "@modules/ui/components/huText"
import { useConfirmPopup } from "@modules/ui/components/popup/huConfirmPopup"
import { useTheme } from "styled-components"

export const useBoxLeadSidebar = () => {
  const { sidebarNavigateTo, hideSidebar } = useSidebar()
  const confirmPopup = useConfirmPopup()
  const theme = useTheme()
  const canSeeLeads = useBoxStaffPermission(BoxStaffPermissions.SEE_LEADS)

  const bodyClosePopup = (
    <div className="flex flex-column align-items-center align-content-center justify-content-center gap-3">
      <HUText fontStyle="TL" color={theme.mainWhite} className="flex">
        {word("boxLead.sidebar.close.title")}
      </HUText>
      <HUText fontStyle="BM" color={theme.neutralColor700} className="flex w-22rem text-center">
        {word("boxLead.sidebar.close.message")}
      </HUText>
    </div>
  )
  const navigateToBoxLeadForm = (boxLead?: BoxLeadEntity) => {
    // PERMISSIONS - Financial permissions denied
    if (!canSeeLeads) {
      return null
    }

    sidebarNavigateTo({
      content: <BoxLeadFormLayout boxLead={boxLead} />,
      replaceAllComponents: true,
      onHide: async () =>
        await new Promise<boolean>((resolve) => {
          confirmPopup.show({
            width: "418px",
            title: "",
            message: bodyClosePopup,
            accept: async () => resolve(true),
            footerProps: {
              align: true,
              cancelText: word("global.cancel"),
              confirmText: word("global.continue"),
              confirmClassName: "flex-1",
              cancelClassName: "flex-1",
              footerClassName: "flex flex-row justify-content-around w-full",
            },
          })
        }),
    })
  }

  return {
    hideSidebar,
    navigateToBoxLeadForm,
  }
}
